import { render, staticRenderFns } from "./EmployeeLastDayPay.vue?vue&type=template&id=bf0ec52a&scoped=true&"
import script from "./EmployeeLastDayPay.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeLastDayPay.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EmployeeLastDayPay.vue?vue&type=style&index=0&id=bf0ec52a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0ec52a",
  null
  
)

export default component.exports